import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { IPersonalAccident } from 'src/app/models/personal-accident.interface';

@Component({
  selector: 'app-pa-list-table',
  templateUrl: './pa-list-table.component.html',
  styleUrls: ['./pa-list-table.component.scss'],
})
export class PaListTableComponent implements OnInit {
  @Input() policies: IPersonalAccident[];
  filteredRows: IPersonalAccident[];
  selectedRecord: IPersonalAccident;
  tableFiltersFormGroup: FormGroup;
  @Input() dataLoaded: boolean;

  constructor(private formBuilder: FormBuilder, private router: Router) {
    this.tableFiltersFormGroup = this.formBuilder.group({
      searchFilter: '',
    });
    this.filterSearchTable();
  }

  ngOnInit(): void {
    this.filteredRows = this.policies;
  }

  filterSearchTable() {
    this.tableFiltersFormGroup
      .get('searchFilter')
      .valueChanges.subscribe((val) => {
        this.filteredRows = this.policies.filter((record) => {
          return Object.keys(record).reduce((acc, curr) => {
            return (
              acc ||
              JSON.stringify(record[curr])
                .toLowerCase()
                .includes(val.toLowerCase())
            );
          }, false);
        });
      });
  }

  goToPolicyDetails(_id: string) {
    this.router.navigate(['/personal-accident/list/pa-details', _id]);
  }

  highlightCancelledPolicies(policy: any) {
    if (policy.hasOwnProperty('cancellation')) {
      return {
        'background-color': '#DB3A34',
        color: '#fff',
      };
    }
  }
}
